/* MY BABY 2026-09-19. Elements carrying data-mb-fit keep their text on ONE
   line with no "..." in every locale: when the rendered text is wider than the
   box the layout gives the element, the font shrinks just enough to fit (never
   below 55% of the CSS size). Hebrew that already fits is left untouched, so
   only the locale that overflows pays. The CSS on these elements must NOT set
   text-overflow: ellipsis (overflow: hidden may stay as the no-JS fallback:
   a clean clip, still no dots). On an element whose CSS allows wrapping this
   is a no-op, because a wrapped line never overflows its box.
   Refits happen on element resize, on font load, when the element scrolls or
   toggles into view (closed dialogs measure as 0-width and are skipped), and
   when other scripts swap the text (variant popout, birthday ticket fields).
   Elements added later (quick-add sheet, collection filtering re-renders,
   theme editor section reloads) register automatically. */
(function () {
  'use strict';

  var FLOOR = 0.55;
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var range = document.createRange();

  function textWidth(el) {
    try {
      range.selectNodeContents(el);
      return range.getBoundingClientRect().width;
    } catch (e) {
      return 0;
    }
  }

  function fit(el) {
    if (!el.isConnected) return;
    if (el.style.fontSize) el.style.fontSize = '';
    var cs = window.getComputedStyle(el);
    var base = parseFloat(cs.fontSize);
    if (!base) return;
    var avail = el.clientWidth
      - (parseFloat(cs.paddingLeft) || 0)
      - (parseFloat(cs.paddingRight) || 0);
    if (avail < 8) return;
    var needed = textWidth(el);
    if (!needed || needed <= avail + 0.5) return;
    var size = Math.max(base * FLOOR, (base * avail) / needed);
    el.style.fontSize = size.toFixed(2) + 'px';
    /* letter-spacing and subpixel rounding are not linear in font-size */
    var after = textWidth(el);
    if (after > avail + 0.5 && size > base * FLOOR) {
      size = Math.max(base * FLOOR, (size * avail) / after);
      el.style.fontSize = size.toFixed(2) + 'px';
    }
  }

  var ro = 'ResizeObserver' in window
    ? new ResizeObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) fit(entries[i].target);
      })
    : null;

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) fit(entries[i].target);
        }
      })
    : null;

  var textObserver = new MutationObserver(function (muts) {
    var hosts = [];
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.nodeType !== 1) t = t.parentElement;
      var host = t && t.closest ? t.closest('[data-mb-fit]') : null;
      if (host && hosts.indexOf(host) === -1) hosts.push(host);
    }
    hosts.forEach(fit);
  });

  function register(el) {
    if (seen) {
      if (seen.has(el)) return;
      seen.add(el);
    }
    if (ro) ro.observe(el);
    if (io) io.observe(el);
    textObserver.observe(el, { childList: true, characterData: true, subtree: true });
    fit(el);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) root = document;
    if (root.nodeType === 1 && root.matches && root.matches('[data-mb-fit]')) register(root);
    var els = root.querySelectorAll('[data-mb-fit]');
    for (var i = 0; i < els.length; i++) register(els[i]);
  }

  function refitAll() {
    var els = document.querySelectorAll('[data-mb-fit]');
    for (var i = 0; i < els.length; i++) fit(els[i]);
  }

  /* For scripts that add data-mb-fit to an existing node or resize its box
     without changing the label's own width (the phone category pills), since
     neither is something the observers above can see. */
  window.MbFitText = {
    fit: function (el) {
      if (!el || !el.hasAttribute('data-mb-fit')) return;
      register(el);
      fit(el);
    }
  };

  function start() {
    scan(document);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refitAll).catch(function () {});
    }
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (e) {
      scan(e.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
